import { Injectable } from '@angular/core';

import { ClientConfigService, NavigationService, ProductHomepagesConfig } from '@frontend/vanilla/core';

import { RewardsHubConfiguration } from '../rewards-hub-config';

@Injectable({ providedIn: 'root' })
export class RewardsHubRouteGuard {
    constructor(
        private clientConfigService: ClientConfigService,
        private rewardsHubConfiguration: RewardsHubConfiguration,
        private productHomePagesConfig: ProductHomepagesConfig,
        private navigationService: NavigationService,
    ) {}

    async canActivate() {
        if (!this.rewardsHubConfiguration.isConfigReady) await this.clientConfigService.load('', [RewardsHubConfiguration]);

        if (this.rewardsHubConfiguration.enableVIPFeature) return true;

        this.navigationService.goTo(this.productHomePagesConfig.promo);
        return false;
    }
}
